import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function storiesgcc({ rtl }) {
  const className = rtl
    ? "normal_section p-100 rtl-style"
    : "normal_section p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="offset-lg-1">
            <h2>قصص نجاح من شركة تطوير التطبيقات لدينا</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              تكريفول حصلت على مكانة موثوقة في صناعة التكنولوجيا العالمية بفضل
              منتجاتها في تطوير تطبيقات الجوال الحديثة، المصممة لخدمة الأعمال في
              جميع أنحاء العالم. العديد من الأعمال التي تستخدم تقنيتنا المتقدمة
              تلاحظ باستمرار نموًا هائلاً في عائداتها الاستثمارية مع زيادة
              إيراداتها الإجمالية. إليكم بعض الحلول المشهورة التي عرضناها أدناه
              لتشهد بنفسك شركتنا موثوقة في تطوير التطبيقات الجوالة.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default storiesgcc;
